import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import * as r from 'vee-validate/dist/rules';
// @ts-ignore
import en from '../resources/validator_uk';

// loop over all rules

// add the rule
let rules: any = r;

for (let rule in rules) extend(rule, rules[rule]);
// messages
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: en.messages[rule] // add its message
  });
}

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
